<script setup lang="ts"></script>
<template>
  <!-- Mirrors ExchangeRate dimensions (28px icon + label), so the swap does not shift the row -->
  <article class="flex items-center gap-2">
    <div class="mr-1 hidden size-7 animate-pulse rounded-full bg-gray-300 sm:block" />
    <div class="h-4 w-[4.5rem] animate-pulse bg-gray-300" />
  </article>
</template>
